module.exports = __webpack_public_path__ + "img/1-3.c3936a1.png";